module.exports = __webpack_public_path__ + "static/media/leftArrow.bee21589.svg";